import { action, ActionType } from "typesafe-actions";

import { Nullable } from "../../../types/common";
import { IError } from "../../../redux/actions/errorHandlingAction";
import { TExecutionBriefResults } from "../../../redux/reducers/executionBriefsReducer";

import { IDuplicateExecutionBriefForm } from "../types/duplicate-execution-brief-form.interface";
import { ExecutionBriefWorkOrdersActionTypes } from "./execution-brief-work-orders/execution-brief-work-orders.actions";

export enum ExecutionBriefActions {
  Duplicate = "ExecutionBrief/Duplicate",
  DuplicateSuccess = "ExecutionBrief/DuplicateSuccess",
  DuplicateFailure = "ExecutionBrief/DuplicateError",
}

export const duplicate = (form: IDuplicateExecutionBriefForm) =>
  action(ExecutionBriefActions.Duplicate, form);
export const duplicateFailure = (error: Nullable<IError>) =>
  action(ExecutionBriefActions.DuplicateFailure, error);
export const duplicateSuccess = (result: TExecutionBriefResults) =>
  action(ExecutionBriefActions.DuplicateSuccess, result);

const actionCreators = {
  duplicate,
  duplicateFailure,
  duplicateSuccess,
};

export type ExecutionBriefActionTypes =
  | ExecutionBriefWorkOrdersActionTypes
  | ActionType<typeof actionCreators>;
